import { selectSignInPage } from '@/lib/frontend/store/helpers';
import { useAppSelector, useAppStore } from '@/lib/frontend/store/hooks';
import * as React from 'react';
import { ProtectedByRecaptcha } from '../ui/recaptcha';
import { FormGroup } from '@/components/ui/form-group';
import { Input } from '@/components/ui/input';
import { Message } from '@/components/ui/message';
import { Button } from '@/components/ui/button';
import RequestUserAccount from '@/lib/frontend/store/actionCreators/RequestUserAccount';

type Props = {
  returnToPath?: string;
};

export const SignUpForm = (props: Props) => {
  const store = useAppStore();
  const signInPage = useAppSelector(selectSignInPage);
  const [processingRequest, setProcessingRequest] = React.useState(false);
  const [form, setForm] = React.useState({ email: '' });

  const signUpRequest = signInPage.signUpRequest;
  const signUpMessage = signUpRequest.value;

  const { email } = form;
  const { errorMessage } = signUpRequest;

  const handleInputChanged = (event: React.ChangeEvent<HTMLInputElement>) => {
    setForm({
      ...form,
      [event.currentTarget.name]: event.currentTarget.value,
    });
  };

  const requestUserAccount = (event: React.FormEvent<HTMLElement>) => {
    event.preventDefault();
    if (processingRequest) {
      return;
    }

    setProcessingRequest(true);

    (async () => {
      await RequestUserAccount(store, {
        Email: form.email,
        Referrer: props.returnToPath,
      });
      setProcessingRequest(false);
    })();
  };

  return (
    <ProtectedByRecaptcha recaptchaID="SignUpFormRecaptcha">
      <form onSubmit={requestUserAccount} className="flex flex-col gap-3 sm:max-w-[24em]">
        <FormGroup label="Email" className="m-0">
          <Input
            type="text"
            name="email"
            value={email}
            onChange={handleInputChanged}
            className="max-w-[unset]"
          />
        </FormGroup>

        {errorMessage && !processingRequest && <Message variant="negative">{errorMessage}</Message>}
        {signUpMessage && !processingRequest && <Message>{signUpMessage}</Message>}

        <Button onClick={requestUserAccount} disabled={processingRequest}>
          Send Registration Link
        </Button>
      </form>
    </ProtectedByRecaptcha>
  );
};
